import { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";

function NSDLPanVerification() {
  const [formData, setFormData] = useState({
    pan_number: "",
    name: "",
    dob: "",
  });
  const [loading, setLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submit = () => {
    if (!formData.pan_number || !formData.name || !formData.dob) {
      setErrorMsg("Please fill all fields.");
      return;
    }
    setErrorMsg("");
    setLoading(true);
    setApiResponse(null);

    const myHeaders = new Headers();
    myHeaders.append("authorizationToken", "DGGQfUc7WQ5774K0");
    myHeaders.append("x-api-key", "CdzP80MUVV3KOCwqSE828ai8jf62aUDb4mg0CAe2");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      pan_number: formData.pan_number,
      name: formData.name,
      dob: formData.dob,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://jegcl1i91e.execute-api.ap-south-1.amazonaws.com/default/panverification",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setApiResponse(result);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setErrorMsg("Something went wrong with the server.");
        setLoading(false);
      });
  };

  return (
    <div className="container containerBoreder">
      <h2 className="pageTitle">NSDL PAN Verification</h2>
      <div className="row mb-3">
        <div className="col-12 col-md-4">
          <input
            type="text"
            name="pan_number"
            className="form-control"
            placeholder="PAN Number"
            value={formData.pan_number}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-4">
          <input
            type="text"
            name="name"
            className="form-control"
            placeholder="Name as per Pan(e.g., Tejas Kadam  )"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-4">
          <input
            type="text"
            name="dob"
            className="form-control"
            placeholder="DOB (DD/MM/YYYY)"
            value={formData.dob}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-12">
          {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
          {!loading ? (
            <button className="btn btn-primary" onClick={submit}>
              Submit
            </button>
          ) : (
            <ReactBootStrap.Spinner animation="border" />
          )}
        </div>
      </div>
      <br />
      {apiResponse && (
        <div className="mt-4">
          {(apiResponse.error || apiResponse.message) ? (
            <div className="alert alert-danger mb-3" role="alert">
              {apiResponse.error || apiResponse.message}
            </div>
          ) : (apiResponse.remark && apiResponse.status != 1 ? (
            <div className="alert alert-warning mb-3" role="alert">
              {apiResponse.remark}
            </div>
          ) : null)}
          
          {(apiResponse.status == 1 || apiResponse.pan_number) && (
            <>
              <b>Verification Result:</b>
              <div className="table-responsive mt-2">
                <table className="table table-bordered table-striped">
                  <tbody>
                    <tr>
                      <th width="30%">Status</th>
                      <td>{apiResponse.status}</td>
                    </tr>
                    <tr>
                      <th>PAN Number</th>
                      <td>{apiResponse.pan_number}</td>
                    </tr>
                    <tr>
                      <th>PAN Status</th>
                      <td>{apiResponse.pan_status}</td>
                    </tr>
                    <tr>
                      <th>Name Match</th>
                      <td>{apiResponse.name_match}</td>
                    </tr>
                    <tr>
                      <th>DOB Match</th>
                      <td>{apiResponse.dob_match}</td>
                    </tr>
                    <tr>
                      <th>PAN Aadhaar Seeding</th>
                      <td>{apiResponse.pan_aadhaar_seeding}</td>
                    </tr>
                    <tr>
                      <th>Remark</th>
                      <td>{apiResponse.remark}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default NSDLPanVerification;
